export default {
    loadedNetworkID: 0,
    loadedTimeframe: "1w",
    topDomains: [],
    mcVersionDistribution: [],
    osVersionDistribution: [],
    attacksMitigated: 0,
    bandwidthUsed: 0,
    bounceRate: 0,
    uniquePlayers: 0,
    playerCount: [],
    connectionCount: [],
};
  